<template>
    <div class="phone-why">
        <a
            href="#"
            class="phone-why-link"
            :aria-expanded="open ? 'true' : 'false'"
            aria-controls="phone-why-box"
            @click.prevent.stop="toggle"
        >Why is a phone number requested</a>

        <!-- v-show, not v-if. The click-outside directive listens on document.body
             and decides "outside" with el.contains(event.target). With v-if, the
             close button is detached from the DOM the instant it is clicked, so
             by the time the event bubbles up the target is no longer inside the
             modal and the whole dialog gets closed instead of just this box.
             v-show keeps it attached. @click.stop is the belt to that braces. -->
        <div v-show="open" id="phone-why-box" class="phone-why-box" role="note">
            <button
                type="button"
                class="phone-why-close"
                aria-label="Close"
                @click.stop="open = false"
            >&times;</button>
            <p>{{ explanation }}</p>
        </div>
    </div>
</template>

<script>
    /**
     * "Why is a phone number requested" disclosure.
     *
     * Shared between the signup form and the post-login prompt for existing
     * users so the wording cannot drift between the two places a customer can
     * meet this question.
     */
    export default {
        data: function() {
            return {
                open: false,
                explanation: 'In the future we will allow you to opt in to text updates ' +
                    'for your order status. Also, as we roll out more courier options, ' +
                    'some require a phone number. And finally, if there is any issue ' +
                    'with your order, such as the coffee is out of stock, we may need ' +
                    'to contact you about a suggested replacement or refund.'
            }
        },
        methods: {
            toggle() {
                this.open = !this.open;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/_variables_home.scss";

    .phone-why {
        margin: 4px 1rem 0;
        text-align: left;
    }

    // Has to read as clickable at a glance -- the ask was specifically for
    // "clickable text". Global anchor rules strip decoration, so both the
    // underline and the colour are set explicitly rather than inherited.
    .phone-why-link,
    .phone-why-link:link,
    .phone-why-link:visited {
        display: inline-block;
        font-size: 13px;
        line-height: 1.3;
        color: $color-primary;
        text-decoration: underline;
        cursor: pointer;
    }

    .phone-why-link:hover {
        color: $color-primary-light;
    }

    // "a small box" -- kept deliberately compact so it explains without
    // shoving the rest of the form around when it opens.
    .phone-why-box {
        position: relative;
        margin-top: 6px;
        padding: 10px 26px 10px 12px;
        border: 1px solid #CFD7DF;
        border-radius: 8px;
        background: #fff;

        p {
            margin: 0;
            font-size: 12px;
            line-height: 1.4;
            color: $color-primary;
            text-align: left;
        }
    }

    .phone-why-close {
        position: absolute;
        top: 4px;
        right: 6px;
        padding: 0;
        border: 0;
        background: none;
        font-size: 16px;
        line-height: 1;
        color: $color-primary-light;
        cursor: pointer;

        &:hover {
            color: $color-primary;
        }
    }
</style>
